<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content below * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced.  * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * Delete the template below * * * * * * * * * -->
<!-- * * * * * * * to get started with your project! * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->

<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content above * * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced.  * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * End of Placeholder  * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
@if (!showAdminLogin) {
<app-navbar [currentTab]="currentTab" (tabChanged)="changeTab($event)"></app-navbar>
}

@if (showAdminLogin) {
<app-admin-login (loginSuccess)="onLoginSuccess()"></app-admin-login>
}

<main class="flex-grow-1">
  @if (isHomeRoute) {
  <app-landing-page *ngIf="currentTab === 'home1'"></app-landing-page>
  <app-pubs-landing-page *ngIf="currentTab === 'home2'"></app-pubs-landing-page>
  }
  <router-outlet></router-outlet>
</main>
@if (footerVisible && !showAdminLogin) {
<app-footer class="mt-auto"></app-footer>
}
<app-toast-container></app-toast-container>